<template>
  <transition name=up>
    <div class="Roulette text-center" v-if="!hide">
      <div class="wrapper">
        <div
          class="body"
          :class="['member' + member.length, {transition}]"
          :style="{backgroundImage: 'url(/static/img/roulette/bg_circle' + member.length + '.png)', transform: 'rotate(' + angle + 'deg)'}"
        >
          <span v-for="(m, i) in member" :key=i :class="{selected: index === i}">
            <span v-if="typeof m === 'string'">{{ m }}</span>
            <span v-else>{{ players.find(p => p.id === m.id).name }}</span>
          </span>
        </div>
      </div>
      <button class="mt-1" @click="hide = true">닫기</button>
      <span class="arrow">
      </span>
      <div class="controller absolute flex-direction-column" v-if="editable">
        <button @click="showRoulette">보이기</button>
        <button @click="hideRoulette">숨기기</button>
        <button @click="setRoulette">설정</button>
        <button @click="runRoulette">돌리기</button>
      </div>
      <div class="data absolute flex-direction-column" v-if="editable">
        <input type="text" v-model="input[0]">
        <input type="text" v-model="input[1]">
        <input type="text" v-model="input[2]">
        <input type="text" v-model="input[3]">
        <input type="text" v-model="input[4]">
        <input type="text" v-model="input[5]">
        <input type="text" v-model="input[6]">
        <input type="text" v-model="input[7]">
        <button @click="setPlayers">플레이어</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Roulette',
  props: ['players', 'permission'],
  data: () => ({
    busy: false,
    hide: true,
    canvas: null,
    member: ['', '', '', '', '', ''],
    input: ['', '', '', '', '', '', '', ''],
    angle: 0,
    transition: true
  }),
  computed: {
    index () {
      try {
        if (this.busy || this.angle === 0) return null

        const members = this.member.length
        const angle = this.angle % 360

        switch (members) {
          case 2:
            return angle < 90 ? 0 : angle < 270 ? 1 : 0
          case 3:
            return angle < 90 ? 0 : angle < 210 ? 2 : angle < 330 ? 1 : 0
          case 4:
            return angle < 45 ? 0 : angle < 135 ? 3 : angle < 225 ? 2 : angle < 315 ? 1 : 0
          case 5:
            return angle < 72 ? 4 : angle < 144 ? 3 : angle < 216 ? 2 : angle < 288 ? 1 : 0
          case 6:
            return angle < 30 ? 0 : angle < 90 ? 5 : angle < 150 ? 4 : angle < 210 ? 3 : angle < 270 ? 2 : angle < 330 ? 1 : 0
          case 7:
            return angle < 51.43 ? 6 : angle < 102.86 ? 5 : angle < 154.29 ? 4 : angle < 205.71 ? 3 : angle < 257.14 ? 2 : angle < 308.57 ? 1 : 0
          case 8:
            return angle < 45 ? 7 : angle < 90 ? 6 : angle < 135 ? 5 : angle < 180 ? 4 : angle < 225 ? 3 : angle < 270 ? 2 : angle < 315 ? 1 : 0
          default:
            return null
        }
      } catch (err) {
        return null
      }
    },
    editable () {
      return ['master', 'manager'].includes(this.permission)
    }
  },
  mounted () {
    setTimeout(() => {
      this.showRoulette()
    }, 1000)
  },
  methods: {
    run (angle) {
      if (this.busy) return
      this.busy = true
      this.angle = this.angle + angle
      setTimeout(() => {
        this.busy = false
      }, 3000)
    },
    showRoulette () {
      if (!this.editable) return
      this.$socket.client.emit('showRoulette')
    },
    hideRoulette () {
      if (!this.editable) return
      this.$socket.client.emit('hideRoulette')
    },
    setRoulette () {
      console.log(this.editable)
      if (!this.editable) return
      this.$socket.client.emit('setRoulette', this.input)
    },
    runRoulette () {
      if (!this.editable) return
      this.$socket.client.emit('runRoulette')
    },
    setPlayers () {
      if (!this.players || !this.players.length) return
      this.players.forEach((p, i) => {
        this.input[i] = p.name
      })
      this.$forceUpdate()
    }
  },
  sockets: {
    showRoulette () {
      this.hide = false
    },
    hideRoulette () {
      this.hide = true
    },
    setRoulette (data) {
      this.transition = false
      setTimeout(() => {
        this.angle = 0
        this.member = data.member
        setTimeout(() => {
          this.transition = true
        }, 100)
      }, 100)
    },
    runRoulette (data) {
      this.run(data.angle)
    }
  }
}
</script>

<style scoped>
.Roulette {
  position: fixed;
  margin: 0 auto;
  bottom: 10vh;
  left: 0;
  right: 0;
  width: 300px;
}
.wrapper {
  position: relative;
  margin: 0 auto;
  width: 300px;
  height: 300px;
  overflow: hidden;
}
.body {
  position: relative;
  width: 300px;
  height: 300px;
  background-size: 300px 300px;
  user-select: none;
}
.body.transition {
  transition: transform 3s ease-out;
}
.body>span {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  transform-origin: 0 120px;
}
.body>span.selected {
  font-weight: 800;
}
.body.member2>span:nth-child(1) {
  transform: rotate(0deg) translate(-50%, 0);
}
.body.member2>span:nth-child(2) {
  transform: rotate(180deg) translate(-50%, 0);
}
.body.member3>span:nth-child(1) {
  transform: rotate(-30deg) translate(-50%, 0);
}
.body.member3>span:nth-child(2) {
  transform: rotate(90deg) translate(-50%, 0);
}
.body.member3>span:nth-child(3) {
  transform: rotate(210deg) translate(-50%, 0);
}
.body.member4>span:nth-child(1) {
  transform: rotate(0deg) translate(-50%, 0);
}
.body.member4>span:nth-child(2) {
  transform: rotate(90deg) translate(-50%, 0);
}
.body.member4>span:nth-child(3) {
  transform: rotate(180deg) translate(-50%, 0);
}
.body.member4>span:nth-child(4) {
  transform: rotate(270deg) translate(-50%, 0);
}
.body.member5>span:nth-child(1) {
  transform: rotate(36deg) translate(-50%, 0);
}
.body.member5>span:nth-child(2) {
  transform: rotate(108deg) translate(-50%, 0);
}
.body.member5>span:nth-child(3) {
  transform: rotate(180deg) translate(-50%, 0);
}
.body.member5>span:nth-child(4) {
  transform: rotate(252deg) translate(-50%, 0);
}
.body.member5>span:nth-child(5) {
  transform: rotate(324deg) translate(-50%, 0);
}
.body.member6>span:nth-child(1) {
  transform: rotate(0deg) translate(-50%, 0);
}
.body.member6>span:nth-child(2) {
  transform: rotate(60deg) translate(-50%, 0);
}
.body.member6>span:nth-child(3) {
  transform: rotate(120deg) translate(-50%, 0);
}
.body.member6>span:nth-child(4) {
  transform: rotate(180deg) translate(-50%, 0);
}
.body.member6>span:nth-child(5) {
  transform: rotate(240deg) translate(-50%, 0);
}
.body.member6>span:nth-child(6) {
  transform: rotate(300deg) translate(-50%, 0);
}
.body.member7>span:nth-child(1) {
  transform: rotate(25.71deg) translate(-50%, 0);
}
.body.member7>span:nth-child(2) {
  transform: rotate(77.14deg) translate(-50%, 0);
}
.body.member7>span:nth-child(3) {
  transform: rotate(128.57deg) translate(-50%, 0);
}
.body.member7>span:nth-child(4) {
  transform: rotate(180deg) translate(-50%, 0);
}
.body.member7>span:nth-child(5) {
  transform: rotate(231.43deg) translate(-50%, 0);
}
.body.member7>span:nth-child(6) {
  transform: rotate(282.86deg) translate(-50%, 0);
}
.body.member7>span:nth-child(7) {
  transform: rotate(334.29deg) translate(-50%, 0);
}
.body.member8>span:nth-child(1) {
  transform: rotate(22.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(2) {
  transform: rotate(67.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(3) {
  transform: rotate(112.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(4) {
  transform: rotate(157.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(5) {
  transform: rotate(202.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(6) {
  transform: rotate(247.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(7) {
  transform: rotate(292.5deg) translate(-50%, 0);
}
.body.member8>span:nth-child(8) {
  transform: rotate(337.5deg) translate(-50%, 0);
}
.arrow {
  display: block;
  position: absolute;
  top: -10px;
  left: 50%;
  width: 26px;
  height: 32px;
  margin-left: -13px;
  background-position: 0 0;
  background: url('/static/img/roulette/arrow.png') no-repeat;
  background-size: 95px 98px;
  z-index: 1;
}
.controller,
.data {
  position: absolute;
  top: 0;
  gap: .5em;
}
.controller {
  right: 110%;
}
.controller button {
  white-space: nowrap;
}
.data {
  left: 110%;
}
.up-enter-active, .up-leave-active {
  transition: transform .5s ease-in-out;
}
.up-enter, .up-leave-to {
  transform: translateY(100vh);
}
</style>



// WEBPACK FOOTER //
// src/components/Roulette.vue